
import { BasicWodData, EnvGlobalsHandler } from "@goodgamestudios/core";
import { GoodgamePartners } from "@goodgamestudios/core";
import { IEnvironmentGlobals } from "@goodgamestudios/core";
import { XMLInterfaceObject } from "@goodgamestudios/core";

import { getDefinitionByName } from "@goodgamestudios/createjs-utilities";

import { getLogger } from "@goodgamestudios/logger";

import { Poker2Constants } from "../../constants/Poker2Constants";
import { AchievementsVO } from "../../gamevo/AchievementsVO";
import { AvatarVO } from "../../gamevo/AvatarVO";
import { BoosterVO } from "../../gamevo/BoosterVO";
import { BuddyVO } from "../../gamevo/BuddyVO";
import { ColorTableVO } from "../../gamevo/ColorTableVO";
import { GiftsVO } from "../../gamevo/GiftsVO";
import { ItemsVO } from "../../gamevo/ItemsVO";
import { LobbyTablesVO } from "../../gamevo/LobbyTablesVO";
import { SocialBuddyVO } from "../../gamevo/SocialBuddyVO";
import { TableListConfigVO } from "../../gamevo/TableListConfigVO";
import { TablesVO } from "../../gamevo/TablesVO";
import { TitlesVO } from "../../gamevo/TitlesVO";
import { TournamentsVO } from "../../gamevo/TournamentsVO";
import { VisualVO } from "../../gamevo/VisualVO";
import { Poker2Model } from "../Poker2Model";

const logger = getLogger("Poker2WodData");

export class Poker2WodData {

    public static ITEMS: string = "Items";
    public static GIFTS: string = "Gifts";
    public static BOOSTER: string = "Booster";
    public static ACHIEVEMENTS: string = "Achievements";
    public static COLOR_TABLE: string = "ColorTable";
    public static TABLES: string = "Tables";
    public static TITLES: string = "Titles";
    public static TOURNAMENTS: string = "Tournaments";

    private static FORCE_EMBED_WORLD_VO_CLASSES: any[] = [
        AvatarVO,
        BuddyVO,
        AchievementsVO,
        BoosterVO,
        ColorTableVO,
        GiftsVO,
        LobbyTablesVO,
        ItemsVO,
        SocialBuddyVO,
        TableListConfigVO,
        TablesVO,
        TitlesVO,
        TournamentsVO
    ];

    protected _voList: Map<number, VisualVO> = new Map();

    constructor(wodXML: XMLInterfaceObject) {
        this.parseVOFromWODXml(wodXML, Poker2WodData.ITEMS);
        this.parseVOFromWODXml(wodXML, Poker2WodData.GIFTS);
        this.parseVOFromWODXml(wodXML, Poker2WodData.BOOSTER);
        this.parseVOFromWODXml(wodXML, Poker2WodData.ACHIEVEMENTS);
        this.parseVOFromWODXml(wodXML, Poker2WodData.COLOR_TABLE);
        this.parseVOFromWODXml(wodXML, Poker2WodData.TABLES);
        this.parseVOFromWODXml(wodXML, Poker2WodData.TITLES);
        this.parseVOFromWODXml(wodXML, Poker2WodData.TOURNAMENTS);
    }

    public getItemVObyID(id: number): VisualVO {
        return this._voList.get(id);
    }

    private parseVOFromWODXml(xml: XMLInterfaceObject, node: string): void {
        var xmlWodList: XMLInterfaceObject[] = xml[node];

        if (xmlWodList != null) {
            for (const wodElement of xmlWodList) {
                if (wodElement === undefined) {
                    continue;
                }

                let id: number = parseInt((wodElement["id"] || ""));
                let vo: VisualVO;

                switch (node) {
                    case Poker2WodData.ITEMS:
                        vo = new ItemsVO();
                        break;

                    case Poker2WodData.GIFTS:
                        vo = new GiftsVO();
                        break;

                    case Poker2WodData.BOOSTER:
                        vo = new BoosterVO();
                        break;

                    case Poker2WodData.ACHIEVEMENTS:
                        vo = new AchievementsVO();
                        break;

                    case Poker2WodData.COLOR_TABLE:
                        vo = new ColorTableVO();
                        break;

                    case Poker2WodData.TABLES:
                        vo = new TablesVO();
                        break;

                    case Poker2WodData.TITLES:
                        vo = new TitlesVO();
                        break;

                    case Poker2WodData.TOURNAMENTS:
                        vo = new TournamentsVO();
                        break;
                }

                vo.fillFromParamXML(wodElement);

                if ("worldIndex" in vo && !this.voIsForWorld(vo["worldIndex"])) {
                    continue;
                }

                this._voList.set(id, vo);
            }
        }
    }

    public buildVoDatas(): void {
        Poker2Model.itemShop.buildShop(this._voList);
        Poker2Model.achievementData.buildAchievement(this._voList);
        Poker2Model.giftData.buildGifts(this._voList);
        Poker2Model.userData.buildTitles(this._voList);
    }

    private voIsForWorld(world: number): boolean {
        switch (world) {
            case 0: return true;
            case 1: return (this.env.isLocal || GoodgamePartners.NETWORK_GENERAL == this.env.networkId || !this.env.hasNetworkBuddies);
            case 2: return (this.env.hasNetworkBuddies);
            default: return true;
        }
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    public get voList(): Map<any, any> {
        return this._voList;
    }
}
